import BasicModel from "./basic_model";

export default class Ball extends BasicModel {

  render = () => {
    this.setupContext();

    let img = document.getElementById("pattern");

    this.context.beginPath();
    this.context.arc(this.x(), this.y(), this.r(), 0, 2 * Math.PI, true);
    this.context.fillStyle = "rgba(255, 255, 255, 1)";
    if (img != null) {
      this.context.fillStyle = this.context.createPattern(img, "repeat");
    }
    this.context.strokeStyle = "rgba(90, 130, 75, 1)";
    this.context.fill();
    this.context.stroke();

    this.resetContext();
  }

  r = () => { return 8 * this.context.scale; }

  boundingBox = () => {
    return {
      x: this.x() - this.r,
      y: this.y() - this.r,
      w: this.r * 2,
      h: this.r * 2
    }
  }
}

